<placeme-layout-seo [seo]="'labsPage.seo' | translate">
  <placeme-jumbotron [seo]="'labsPage.seo' | translate"></placeme-jumbotron>
  <section class="main-content labs">
    <markdown class="page-markdown" [data]="'labsPage.content' | translate"></markdown>

    <div class="labs__container">
      <a class="card" target="_blank" [href]="item.link" *ngFor="let item of labs; trackBy: trackBySeo">
        <div class="card__img">
          <img
            *ngIf="item"
            [src]="
              item?.seo
                | seoImageUrl
                  : {
                      text: false,
                      format: 'rectangle',
                      logo: true,
                      category: item?.__typename
                    }
            "
            [alt]="item?.seo?.title"
            [title]="item?.seo?.title"
          />
        </div>
        <div class="card__container">
          <h3 class="card__container__title">{{ item?.seo?.title }}</h3>
          <p class="card__container__description">{{ item?.seo?.description }}</p>
        </div>
      </a>
    </div>
    <p *ngIf="labs && !labs.length" class="labs__empty">{{ 'labsPage.emptyContent' | translate }}</p>
  </section>
</placeme-layout-seo>
